import { render, staticRenderFns } from "./NonEligible.vue?vue&type=template&id=10670b5c&scoped=true&"
import script from "./NonEligible.vue?vue&type=script&lang=js&"
export * from "./NonEligible.vue?vue&type=script&lang=js&"
import style0 from "./NonEligible.vue?vue&type=style&index=0&id=10670b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10670b5c",
  null
  
)

export default component.exports